import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import { Flex } from "antd";
import { useSearchParams } from "react-router-dom";
import { useApiRequest } from "@utils/ApiRequest";
import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";

const ActivateUser = () => {
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const verificationCode =
    searchParams.get("verification_code") || searchParams.get("code");
  const { patchUserActivate } = useApiRequest();
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const { mutate } = useMutation({
    mutationFn: (code: string) => patchUserActivate(code),
    onSuccess: () => {
      setIsSuccess(true);
    },
    onError: (error: any) => {
      const errorCode = error?.response?.data?.error_code;
      if (errorCode === "1008") {
        setErrorMessage(
          "인증 링크가 만료되었습니다. 회원가입 페이지에서 다시 인증해주세요.",
        );
      } else {
        setErrorMessage("인증에 실패했습니다. 다시 시도해주세요.");
      }
    },
  });

  useEffect(() => {
    if (verificationCode) {
      mutate(verificationCode);
    }
  }, [verificationCode, mutate]);

  return (
    <Container>
      <ContentWrapper>
        {isSuccess ? (
          <>
            <Image
              src={theme.image.check_circle.default}
              height="6rem"
              width="6rem"
            />
            <Flex vertical gap={"3rem"}>
              <Message>{"이메일 인증이 완료되었습니다."}</Message>
              <Flex vertical gap={"0.5rem"} align="center">
                <SubMessage>
                  {"앱으로 돌아가서 '인증 완료 확인' 버튼을 눌러주세요."}
                </SubMessage>
              </Flex>
            </Flex>
          </>
        ) : errorMessage ? (
          <Message>{errorMessage}</Message>
        ) : (
          <Message>{"인증 처리 중..."}</Message>
        )}
      </ContentWrapper>
    </Container>
  );
};

export default ActivateUser;

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  position: "relative",
  height: "100dvh",
  padding: "2rem",
});

const ContentWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const Message = styled.p(({ theme }) => ({
  fontSize: "2.4rem",
  marginTop: "4rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  fontWeight: theme.fontWeight.medium,
}));

const SubMessage = styled.p({
  fontSize: "1.6rem",
  textAlign: "center",
});
